const queue = [];

let isIE = false;

if (window && window.navigator && window.navigator.appVersion) {
	if (window.navigator.appVersion.indexOf("MSIE 9.0") !== -1 ||
		window.navigator.appVersion.indexOf("MSIE 10.0") !== -1) {
		isIE = true;
	}
}

document.addEventListener("DOMContentLoaded", () => {
	queue.forEach((entry) => entry.done(entry.args));
});

const readyStates = {
	complete: 1,
	loaded: 1,
	interactive: 1,
};

export default function OnDOMReady(done, ...args) {
	if (readyStates[document.readyState]) {
		if (isIE) {
			setTimeout(() => {
				done(args);
			}, 2000);
		} else {
			done(args);
		}
	} else {
		queue.push({ args, done });
	}
}



// WEBPACK FOOTER //
// ./src/shared/util/OnDOMReady.js